<header class="top-header-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-5">
                <ul class="social-links">
                    <li>Follow Us:</li>
                    <li><a href="https://www.facebook.com/osit.com.sa/" target="_blank"><i class="icofont-facebook"></i></a></li>
                    <li><a href="https://twitter.com/osit_sa" target="_blank"><i class="icofont-twitter"></i></a></li>
                    <li><a href="https://www.instagram.com/osit_sa/" target="_blank"><i class="icofont-instagram"></i></a></li>
                    <li><a href="https://www.linkedin.com/company/osit-sa/" target="_blank"><i class="icofont-linkedin"></i></a></li>
                </ul>
            </div>
            
            <div class="col-lg-7 col-md-7">
                <ul class="header-info">
                    <li><a href="https://support.osit.com.sa">Support</a></li>
                    <li><a routerLink="/career">Career</a></li>
                    <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    <li><a routerLink="/quotation-request">Get Quotation</a></li>
                </ul>
            </div>
        </div>
    </div>
</header>